import { useState } from "react";
import classNames from "classnames";

import { LocationIcon, UsersIcon, MoreIcon } from "../../AscIcons";
import { pluralizeIfNecessary } from "@ascendnow/shared";

import styles from "./AscCompanyCard.module.scss";
import AscHeading from "../../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";
import AscButton from "../../AscButton/AscButton";

interface TagDataTypes {
  tag: string
}

interface CompaniesDataTypes {
  id: string,
  logo: {
    key: string,
    location: string
  },
  title: string,
  country: string,
  city: string,
  employees: string,
  tags: Array<TagDataTypes> | [],
  vacanciesCount: number
}

interface AscCompanyCardProps extends CompaniesDataTypes {
  className?: string,
  onClick?: () => void,
  onEdit?: (e: any) => void;
  onRemove?: (e: any) => void;
}

export default function AscCompanyCard({
  className,
  logo,
  title,
  country,
  city,
  employees,
  tags = [],
  vacanciesCount,
  onClick,
  onEdit,
  onRemove
}: AscCompanyCardProps) {
  const [showAction, setShowAction] = useState<boolean>(false);

  const imageUrl = logo?.location;

  return (
    <div
      data-testid="asc-company-card"
      className={classNames(styles.ground, className)}
    >
      {imageUrl && (
        <img className={styles.image} src={imageUrl} alt={imageUrl} />
      )}

      <div className={styles.infoGround} onClick={onClick}>
        <div className={styles.topSection}>
          <AscHeading className={styles.companyName} level={6}>
            {title}
          </AscHeading>
          <AscParagraph className={styles.jobs}>{vacanciesCount} {pluralizeIfNecessary('Job', vacanciesCount)} </AscParagraph>
          <MoreIcon 
            className={styles.icon}
            onClick={(e) => {
              e.stopPropagation();
              setShowAction(!showAction)
            }
            }
          />

          {showAction && (
            <AscAdminAction
              option1={"Edit"}
              option2={"Remove"}
              clickOption1={onEdit}
              clickOption2={onRemove}
              className={styles.actionBar}
            />
          )}
        </div>

        <div className={styles.middleSection}>
          <LocationIcon className={styles.icon} />
          <AscParagraph className={styles.text}>{country}, {city}</AscParagraph>

          <UsersIcon className={styles.icon} />
          <AscParagraph className={styles.text}>{employees}</AscParagraph>
        </div>

        <div className={styles.bottomSection}>
          {tags?.map((tag, index) =>  (
            <AscButton
              key={index}
              className={classNames(styles.button, styles.blueButton)}
              variant="secondary"
              size="small"
            >
              {tag.tag}
            </AscButton>)
          )}
        </div>
      </div>
    </div>
  );
}
